import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Campaign } from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";

import StyledTextField from "components/Styled/TextField";
import { addBusinessDays } from "utils/time";

interface Props {
  campaign: Campaign | null;
  open: boolean;
  loading?: boolean;
  handleClose: () => void;
  handleConfirm: (startDate: string) => void;
}

export default function ResumeCampaignDialog({
  campaign,
  open,
  loading,
  handleClose,
  handleConfirm,
}: Props) {
  const minDate = addBusinessDays(1).toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(minDate);

  useEffect(() => {
    if (open) setStartDate(minDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>Resume campaign</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Pick a new start date. We&apos;ll reschedule outreach for the
          remaining brands in
          {campaign?.name ? ` "${campaign.name}"` : " this campaign"} starting
          on that date.
        </DialogContentText>
        <StyledTextField
          label="Start Date"
          type="date"
          required
          fullWidth
          value={startDate}
          onChange={(e: CustomEvent) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: minDate }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} sx={{ color: "purple.main" }}>
          Cancel
        </Button>
        {loading ? (
          <LoadingButton loading={loading}>Resume</LoadingButton>
        ) : (
          <Button
            onClick={() => handleConfirm(startDate)}
            disabled={!startDate}
          >
            Resume
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
